// Login.js
import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import logo from '../logo.png';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);

      localStorage.setItem('token', data.token);
      localStorage.setItem('role', data.role);
      localStorage.setItem('username', data.username);
      localStorage.setItem(
        'apiBaseUrl',
        window.location.hostname.includes('localhost')
          ? `http://localhost:3001`
          : `https://${window.location.hostname}`
      );
      navigate('/'); // ✅ redirect after login
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src={logo} alt="Logo" className="login-logo" />
        <br></br><small><b>Drilling Data Management System</b></small>
        <h2>Login</h2>
        <input
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
        />
        <input
          placeholder="Password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <button onClick={handleLogin}>Login</button>

        {/* Optional QR display */}
        <p>Scan to access:</p>
        <QRCodeCanvas value={window.location.href} size={128} />
        <p style={{ fontSize: '0.8em' }}>{window.location.href}</p>
      </div>
    </div>
  );
}
